import { theme } from 'modules/ui';
import { Flex } from 'modules/ui/flex';
import { setIconColor } from 'modules/utils';
import styled from 'styled-components';
import { NavigationAndActionInfoSmall as TooltipIcon } from '../../icons';

export const StyledInputWithLabel = styled(Flex)<{
  width?: React.CSSProperties['width'];
  filled?: boolean;
}>`
  width: ${(props) => (props.width ? ` ${props.width}` : ' 100%')};
  background-color: ${({theme}) => theme.colors.primaryW};
  
  :hover label {
    ${(props) =>
      props.filled
        ? `
          color: ${props.theme.colors.primaryK10};
        `
        : ''}
  }

  :focus-within label {
    color: ${({theme}) => theme.colors.primaryK7};
  }
`;

export const InputLabel = styled.label<{
  disabled?: boolean;
  readOnly?: boolean;
  filled?: boolean;
}>`
  color: ${(props) =>
    props.filled
      ? ` ${props.theme.colors.primaryK7}`
      : ` ${props.theme.colors.primaryK10}`};

  font-weight: ${theme.fontWeight.thin};
  font-size: var(--main-font-size);
  line-height: var(--main-line-height);
  word-spacing: var(--word-spacing);
  margin-bottom: 0.125rem;
  user-select: none;

  ${(props) =>
    props.disabled || props.readOnly
      ? `
          color: ${props.theme.colors.primaryK7};
        `
      : ''}
`;

export const StyledTooltipIcon = styled(TooltipIcon)`
  height: 1.125rem;
  width: 1.125rem;
  transition: all 0.15s linear;
  fill: ${({theme}) => theme.colors.primaryK10};

  &:hover {
    ${({theme}) => setIconColor(theme.colors.primaryT2)};
  }
`;
